import { z } from 'zod';

export const zodDeliveryNotesByIdsAdminRequestSchema = z.object({
  ids: z.array(z.uuid()).min(1),
});
